import script from "./PDFPageNavigator.vue?vue&type=script&setup=true&lang=ts"
export * from "./PDFPageNavigator.vue?vue&type=script&setup=true&lang=ts"

import "./PDFPageNavigator.vue?vue&type=style&index=0&id=45e4819f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e4819f"]])

export default __exports__